export default __webpack_public_path__ + "710dc6d21d44a3c345119e740fcf211f.png";